import React from 'react';

const Footer = () => {
  const footerStyle = {
    backgroundColor: '#2d3a3a',
    color: 'white',
    textAlign: 'center',
    padding: '1rem 0',
    position: 'relative', // Use absolute positioning to keep it at the bottom of the page
    bottom: '0',
    left: '0',
    right: '0',
    width: '100%', // Full width
    marginLeft: 'auto',
    marginRight: 'auto',
    // Additional adjustments to ensure it stays at the bottom
    zIndex: 10,
    borderRadius: '2rem'
  };

  const footerContentStyle = {
    margin: 0,
    fontSize: '1rem',
  };

  const socialLinksStyle = {
    margin: '10px 0',
  };

  const socialLinkStyle = {
    margin: '0 10px',
    color: 'white',
    textDecoration: 'none',
  };

  const socialLinkHoverStyle = {
    color: '#ffa500',
  };

  return (
    <footer style={footerStyle}>
      <div style={footerContentStyle}>
        <p style={{fontStyle: "italic"}}>“ Smart Moves. Real Growth. Build Your Legacy."</p>
        <p>© 2025 Wise Wealth. All rights reserved.</p>
        <div style={socialLinksStyle}>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" style={socialLinkStyle}>X (twitter)</a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={socialLinkStyle}>LinkedIn</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
